<template>
  <div class="border-footer border-footer-btm"></div>
</template>

<script>
export default {
  name: 'BorderFooterBottom'
}
</script>
